import gql from "graphql-tag";
import { PageFragment } from "../fragments/page.fragment";
import { RebateFragment } from "../fragments/rebate.fragment";

export const GET_REBATES = gql`
  query {
    rebates(sorting: [{ field: toDate, direction: DESC }]) {
      pageInfo {
        ...Page
      }
      edges {
        node {
          ...Rebate
        }
      }
    }
  }
  ${PageFragment}
  ${RebateFragment}
`;
